import React from 'react';
import githubImg from '../assets/img/github-logo2.png';

const Github = ({ data }) => {
  return (
    <div className="container" id="github">
      <h1 className="title__focus">Github Proyect</h1>
      <h3>Press the image to go to the github code</h3>
      <div className="github ">
        <div className="github__url">
          <a target="_blank" href={data[0].github}>
            <img src={githubImg} alt={data[0].github} className="animate__animated animate__pulse animate__fast animate__infinite" />
          </a>

        </div>
      </div>
    </div>
  );
}

export default Github;
